import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import mainStyle from "../../../mainStyle.module.scss";
import useDataSourceManager from "hooks/useDataSourceManager";
import { v4 as uuidv4 } from "uuid";
import { isEqual, cloneDeep } from "lodash";
import {
  Box,
  Button,
  Typography,
  Tooltip,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import ModalContainer from "components/ModalContainer";
import { getAvailableAggregateGroupId } from "../../helper";
import { MenuSelect } from "components/Select/menuSelect";
import CustomMenu from "components/Menu";
import ChipTag from 'components/ChipTag';

import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import { ReactComponent as AlertIcon } from "assets/images/icons/icn_board_alert.svg";
import { ReactComponent as ExpandIcon } from "assets/images/icons/btn_topology_expand.svg";
import { ReactComponent as CheckedIcon } from "assets/images/icons/icn_checked.svg";
import { ReactComponent as UnCheckedIcon } from "assets/images/icons/icn_unchecked.svg";
import { ReactComponent as CheckChangedIcon } from "assets/images/icons/icn_check_changed.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";

const AggregationConfirmModal = ({
  showAggregationConfirmModal,
  setShowAggregationConfirmModal,
  onProceedCallback,
}) => {
  const theme = useTheme();

  return (
    <ModalContainer
      display={showAggregationConfirmModal}
      modalWidth="500px"
    >
      <Box sx={{ p: 1 }}>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: "bold",
            color: theme.palette.primary.main,
            mb: 2
          }}
        >
          Attention Required
        </Typography>
        <Typography sx={{ fontSize: 14, color: "text.primary", mb: 3 }}>
          Applying changes will automatically synchronize settings and overwrite configurations on all selected aggregation ports.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <OutlineButton
            onClick={() => setShowAggregationConfirmModal(false)}
            width="100px"
            height="32px"
          >
            Cancel
          </OutlineButton>
          <SolidButton
            onClick={() => {
              setShowAggregationConfirmModal(false);
              onProceedCallback();
            }}
            width="100px"
            height="32px"
          >
            Proceed
          </SolidButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default AggregationConfirmModal;
